import { createSlice } from "@reduxjs/toolkit";
import { getRedeemCodeUsageList } from "./thunk";

export interface IState {
  lstRedeemCodeUsage: any;
  isRedeemCodeUsageLoading: boolean;
  isRedeemCodeUsageSuccess: boolean;

  error: any;
}

export const initialState: IState = {
  lstRedeemCodeUsage: null,
  isRedeemCodeUsageLoading: false,
  isRedeemCodeUsageSuccess: false,

  error: {},
};

const RedeemCodeUsageSlice = createSlice({
  name: "RedeemCodeUsage",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get Advertisements
    builder.addCase(
      getRedeemCodeUsageList.pending,
      (state: IState, action: any) => {
        state.isRedeemCodeUsageLoading = true;
      }
    );
    builder.addCase(
      getRedeemCodeUsageList.fulfilled,
      (state: IState, action: any) => {
        state.lstRedeemCodeUsage = action.payload.data;
        state.isRedeemCodeUsageSuccess = true;
        state.isRedeemCodeUsageLoading = false;
      }
    );
    builder.addCase(
      getRedeemCodeUsageList.rejected,
      (state: IState, action: any) => {
        state.error = action.payload.error || null;
        state.isRedeemCodeUsageSuccess = false;
        state.isRedeemCodeUsageLoading = false;
      }
    );
  },
});

export default RedeemCodeUsageSlice.reducer;
